import { FieldValues, useController } from 'react-hook-form'
import { RhfProps } from './rhf.props'
import { TimePickerFieldProps } from '../time-picker-field/time-picker-props'
import { TimePickerField } from '../time-picker-field'

export type TimePickerFieldRhf<T extends FieldValues> = RhfProps<T> & TimePickerFieldProps

export function TimePickerFieldRhf<T extends FieldValues>({
  name,
  defaultValue,
  control,
  rules = {},
  required,
  ...datePickerProps
}: TimePickerFieldRhf<T>) {
  if (required) {
    rules.required = 'This field is required'
  }

  const startController = useController({
    name,
    control,
    rules,
    defaultValue,
  })

  let hasError = !!startController.fieldState.error
  const isDirty = startController.fieldState.isDirty

  return (
    <TimePickerField
      {...datePickerProps}
      required={!!rules?.required}
      onChange={(time) => {
        startController.field.onChange(time)
      }}
      value={startController.field.value}
      helperText={hasError ? startController.fieldState.error?.message : datePickerProps.helperText}
      error={hasError}
      isDirty={isDirty}
    />
  )
}
